import React from 'react'
import { ChainId } from '@mprolab/sdk'
import { Arbitrum, BNBChain, Base, Ethereum, Polygon } from '../components/Svg'

export const getChainIconByChainId = (chainId?: ChainId, width?: string, height?: string) => {
  switch (chainId) {
    case ChainId.BSC_MAINNET:
    case ChainId.BSC_TESTNET:
      return <BNBChain {...{ width, height }} />
    case ChainId.ETH_MAINNET:
    case ChainId.ETH_GOERLI:
    case ChainId.ETH_SEPOLIA:
      return <Ethereum {...{ width, height }} />
    case ChainId.MATIC_MAINNET:
    case ChainId.MATIC_TESTNET:
      return <Polygon {...{ width, height }} />
    case ChainId.ARBITRUM_MAINNET:
    case ChainId.ARBITRUM_TESTNET:
      return <Arbitrum {...{ width, height }} />
    case ChainId.BASE_MAINNET:
    case ChainId.BASE_TESTNET:
      return <Base {...{ width, height }} />
    default:
      return <></>
  }
}
